
// create the config file datas here
export const COURSES = {
    
    // GENERAL APP INDIVIDUAL COURSE CATEGORY ITEMS
    TRENDING_COURSES: [

        {
            "courseImg": "/app_images/courses/course_1.webp",
            "course_details_link": "/course/details",
            "courseTitle": "The Complete Web Development Course: From Zero to Expert!",
            "lesson": "12",
            "student": "500",
            "desc": "Master Python by building 100 projects in 100 days. Learn data science, automation, build websites, games and apps!",
            "instructorImg": "/app_images/courses/instructor_1.webp",
            "instructorName": "Claudia Pruitt",
            "instructorProfile": "/Claudia_Pruitt",
        },
        {
            "courseImg": "/app_images/courses/course_2.webp",
            "course_details_link": "/course/details",
            "courseTitle": "Difficult Things About Education.",
            "lesson": "14",
            "student": "350",
            "desc": "Master Python by building 100 projects in 100 days. Learn data science, automation, build websites, games and apps!",
            "instructorImg": "/app_images/courses/instructor_2.webp",
            "instructorName": "Fred Guer",
            "instructorProfile": "/Fred_Guer",
        },
        {
            "courseImg": "/app_images/courses/course_3.webp",
            "course_details_link": "/course/details",
            "courseTitle": "Five Things You Should Do In Education.",
            "lesson": "11",
            "student": "200",
            "desc": "Master Python by building 100 projects in 100 days. Learn data science, automation, build websites, games and apps!",
            "instructorImg": "/app_images/courses/instructor_3.webp",
            "instructorName": "Levi Arm",
            "instructorProfile": "/Levi_Arm",
        },
        {
            "courseImg": "/app_images/courses/course_4.webp",
            "course_details_link": "/course/details",
            "courseTitle": "The Complete Web Development Course: From Zero to Expert!",
            "lesson": "16",
            "student": "50",
            "desc": "Master Python by building 100 projects in 100 days. Learn data science, automation, build websites, games and apps!",
            "instructorImg": "/app_images/courses/instructor_1.webp",
            "instructorName": "Mark Jury",
            "instructorProfile": "/MarkJury",
        }
        
    ]
      

};